<template>
  <div>
    <div class="contents">
      <header>
        <div style="display: inherit; margin: auto" v-if="error === ''">
          <div class="istrow" v-if="!loggedInByUnilogin">
            <div class="cute-7-tablet">
              <h2>Aktiver Unilogin til Dagtilbud Personale</h2>
              Du bedes logge ind med din personlige Unilogin bruger for at verificere dig som bruger
              af Dagtilbud Personale på
              <b>{{ institutionName }}</b
              >. <br /><br />
              <q-btn
                color="primary"
                class="full-width"
                label="Gå til Unilogin"
                @click="goToUnilogin"
              />
            </div>
            <div class="cute-5-tablet" style="text-align: center"></div>
          </div>
          <div class="cute-12-tablet" v-if="loggedInByUnilogin"></div>
          <div class="istrow" v-if="loggedInByUnilogin">
            <div class="cute-8-tablet">
              <h2>Sådan, du er næsten færdig</h2>
              Du bedes indtaste dit cpr-nummer og dit bopæls-postnummer for endelig verificering.
              <q-banner
                v-if="formError.indexOf(cprErrorMessage) > -1"
                rounded
                inline-actions
                class="bg-orange text-white errorbanner"
              >
                Er dit cprnummer indtastet korrekt og du stadig får en valideringsfejl, kan der være
                en login session der ikke er logget af. Luk browseren helt og klik på linket i din
                aktiveringsmail for at prøve igen.
              </q-banner>
            </div>
            <div class="cute-4-tablet">
              <q-card class="f-card">
                <q-card-section>
                  <div class="istrow">
                    <div class="cute-12-tablet">
                      <ISTFormInput
                        v-model="ssn"
                        type="text"
                        :label="$t('employees.ssn')"
                        v-bind:input-class="{ hidesensitive: isPwd }"
                      >
                        <template v-slot:append>
                          <q-icon
                            :name="isPwd ? 'visibility_off' : 'visibility'"
                            class="cursor-pointer"
                            @click="isPwd = !isPwd"
                          ></q-icon>
                        </template>
                      </ISTFormInput>
                    </div>
                    <div class="cute-12-tablet">
                      <ISTFormInput v-model="postalCode" label="Bopæls-postnummer." type="text" />
                    </div>

                    <div class="cute-12-tablet">
                      <q-btn
                        color="primary"
                        class="full-width"
                        label="Aktiver"
                        @click="activateUser"
                      />
                    </div>
                    <div
                      class="cute-12-tablet"
                      v-if="formError !== ''"
                      v-html="formError"
                      style="color: red"
                    ></div>
                  </div>
                </q-card-section>
              </q-card>
            </div>
          </div>
        </div>
        <div style="display: inherit; margin: auto" v-if="error !== ''">
          <div class="cute-12-tablet">
            <div v-if="!alreadyCreated && !tokenExpired">
              <h2>Der er sket en fejl</h2>

              Prøv igen ved at klikke på linket i din aktiveringsmail, for at aktivere din bruger
              til IST Dagtilbud Personale. <br />
              Hvis det ikke afhjælper problemet, kan du kontakte vores support på grundskole@ist.dk,
              eller på tlf. 46 76 18 89.
            </div>
            <div v-if="!alreadyCreated && tokenExpired">
              <h2>Der er sket en fejl</h2>
              Dit aktiveringslink for at oprette bruger via Unilogin på IST Dagtilbud Personale, er
              udløbet.
              <br /><br />
              Er du eksisterende bruger af IST Dagtilbud Personale kan du logge ind med dit
              nuværende brugernavn og adgangskode på dagtilbudpersonale.ist.com, for at få tilsendt
              en ny aktiveringsmail.
              <br /><br />
              <q-btn color="primary" class="full-width" @click="redirectToLoginPage">
                Gå til login
              </q-btn>
              <br /><br />
              Er du helt ny bruger eller har andre loginproblemer kan du kontakte vores support på
              grundskole@ist.dk, eller på tlf. 46 76 18 89.
            </div>
            <div v-if="alreadyCreated">
              <h2>Du er allerede oprettet som bruger</h2>
              Du er allerede oprettet som bruger på IST Dagtilbud Personale.
              <br />
              Du bedes gå til dagtilbudpersonale.ist.com og logge ind med din Unilogin bruger.

              <br /><br />
              Har du brug for hjælp kan du kontakte vores support på grundskole@ist.dk, eller på
              tlf. 46 76 18 89.
              <br /><br />
              <q-btn color="primary" class="full-width" @click="redirectToLoginPage">
                Gå til Dagtilbud Personale
              </q-btn>
            </div>

            <br /><br />
            <div>{{ error }}</div>
          </div>
        </div>
      </header>
    </div>
  </div>
</template>
<script lang="ts">
import { Vue } from "vue-property-decorator";
import store from "@/store";
import { LocationQueryValue, useRouter } from "vue-router";
import { IUserActivation } from "../modules/security/models/user-model";
import { loginService } from "@/modules/security/service/login.service";
import { errorMessage } from "@/utils/errorMessageUtils";
import { isStringNumber } from "@/utils/numberUtils";

export default class IDA extends Vue {
  router = useRouter();
  ssn = "";
  postalCode = "";
  error = "";
  loggedInByUnilogin = false;
  mailtoken: LocationQueryValue | LocationQueryValue[] = "";
  institutionName = "";
  institutionCode = -1;
  alreadyCreated = false;
  tokenExpired = false;
  formError = "";
  isPwd = true;
  cprErrorMessage = "Angivet cprnummer kunne ikke valideres i forhold til Unilogin";

  async mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    this.mailtoken = urlParams.get("token");
    const hasStateStub = location.href.includes("#state=");

    if (this.mailtoken !== "" && this.mailtoken !== null) {
      // New user have clicked link in activation mail
      loginService
        .getInstitutionByToken(this.mailtoken.toString())
        .then((institution) => {
          this.institutionName = institution.name;
          this.institutionCode = institution.code ? institution.code : -1;
        })
        .catch((e) => {
          const error = errorMessage(e);
          if (error.indexOf("Bruger aktiverings fejl, bruger er oprettet på token:") > -1) {
            this.alreadyCreated = true;
            this.error = "Error code: 003 (user already exists)";
          } else if (error.indexOf("Bruger aktiverings fejl, token er ikke valid:") > -1) {
            this.error = "Error code: 004 (non valid token)";
          } else if (error.indexOf("Bruger aktiverings fejl, token er udløbet:") > -1) {
            this.error = "Error code: 005 (expired token)";
            this.tokenExpired = true;
          } else {
            this.error = "Error unknown " + new Date().toString();
          }
        });
    } else if (this.mailtoken === null && hasStateStub) {
      if (localStorage.getItem("userActivation") !== null) {
        // New user have logged in by Unilogin
        this.loggedInByUnilogin = true;
        // To get keycloak token we need call loginIdp
        store.dispatch("security/getIdpToken");
        //store.dispatch("security/getUser", true);
      } else {
        this.error = "Error code: 001 (no local storage)";
      }
    } else {
      this.error = "Error code: 002 (no token or state) ";
    }
  }

  async goToUnilogin() {
    if (!this.mailtoken) {
      return;
    }
    const obj: IUserActivation = {
      date: new Date(),
      mailToken: this.mailtoken.toString(),
      accessToken: "",
      institutionName: this.institutionName,
      code: this.institutionCode
    };
    localStorage.setItem("userActivation", JSON.stringify(obj));
    await store.dispatch("security/logout", true);
    store.dispatch("security/loginIdp").catch((e) => {
      this.error = new Date().toString() + ": " + errorMessage(e);
    });
  }

  activateUser() {
    this.formError = "";
    const ssn = this.ssn.trim().replace("-", "");
    const postalCode = this.postalCode.trim();
    if (ssn === "" || postalCode === "") {
      this.formError = "Cpr nr. og bopæls-postnummer er påkrævet";
    } else if (ssn.length !== 10 || !isStringNumber(ssn)) {
      this.formError = "Cpr nr. er ikke i korrekt format ex. 1510901234 eller 151090-1234";
    } else if (postalCode.length !== 4 || !isStringNumber(postalCode)) {
      this.formError = "Bopæls-postnummer skal være numerisk og 4 cifre";
    }
    if (this.formError !== "") {
      return;
    }
    const jsonString = localStorage.getItem("userActivation");
    if (jsonString !== null) {
      const firstIndexOfHashtag = location.href.indexOf("#");
      let newPath = location.href;
      if (firstIndexOfHashtag) {
        newPath = location.href.substring(0, firstIndexOfHashtag);
      }
      store
        .dispatch("security/activateUser", {
          ssn: ssn,
          postalCode: this.postalCode
        })
        .then(() => {
          localStorage.removeItem("userActivation");
          store
            .dispatch("security/applicationAuthenticate")
            .then(() => {
              newPath += "module/dashboard";
              history.pushState("", "main", newPath);
              this.router.push({ name: "dashboard" });
            })
            .catch((error) => {
              this.error = "Error unknown " + new Date().toString();
              console.log("router security/loginidp rejected: ", error["errors"][0].message);
            });
        })
        .catch((e) => {
          this.formError = errorMessage(e);
        });
    }
  }

  redirectToLoginPage() {
    this.router.push({ name: "home" });
  }
}
</script>
<style>
@font-face {
  font-family: "password-mask";
  src: url(data:font/woff;charset:utf-8;base64,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)
    format("woff");
}
.hidesensitive {
  font-family: password-mask;
}
.hidesensitive::placeholder {
  font-family: initial;
}
</style>
<style scoped>
body {
  margin: 0;
  padding: 0;
  background-color: #589dc9;
  text-align: left;
}

header {
  width: 100%;
  background-color: #006a83;
  color: #fff;
  display: table;
}
header > div {
  vertical-align: top;
  height: 100%;
  overflow: auto;
  padding: 3vw;
  background-color: inherit;
}
header h2 {
  margin-top: 0;
  color: #fff;
}
.contents {
  max-width: 960px;
  width: 94%;
  margin: auto;
  margin-top: 3vw;
}
</style>
